<template>
    <div class="flex flex_column">
        <div v-for="account in accounts" :key="account.id" class="flex">
            <md-switch v-model="accountLimitMapping[account.id].isAssigned"
                       :disabled="!canEditAccounts"
                       class="margin_horizontal"
            ></md-switch>
            <md-field displayOnly class="margin_r" style="width: 225px; flex-shrink: 0">
                <label>{{account.tag}}</label>
                <md-input :value="account.tbIban + ' (' + account.tbCurrType + ')'" disabled></md-input>
            </md-field>
            <md-checkbox v-model="accountLimitMapping[account.id].withoutLimit"
                         :disabled="!canEditLimits"
                         class="margin_r" style="width: 120px; flex-shrink: 0">
                <span>{{ $t("manageUser.limits.without") }}</span>
            </md-checkbox>
            <md-field v-show="!accountLimitMapping[account.id].withoutLimit" class="margin_r flex_1">
                <label>{{ $t("manageUser.limits.buy") }}</label>
                <MoneyAmountInput v-model="accountLimitMapping[account.id].maxBuyAmount"
                                  :disabled="!canEditLimits"
                ></MoneyAmountInput>
            </md-field>
        </div>
        <div class="text_left light_bg_color margin_horizontal">
            <span class="font_bold">{{$t("common.hint")}}:</span>
            <br/>
            <span>{{$t("manageUser.limits.buy.hint")}}</span>
        </div>
    </div>
</template>

<script>
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";

export default {
    props: {
        userData: { type: Object, default: null },
        accounts: { type: Array, default: null },
        assignedAccounts: { type: Array, default: null },
        limits: { type: Array, default: null },
        canEditLimits: { type: Boolean, default: false },
        canEditAccounts: { type: Boolean, default: false },
		isDeputyGranted: { type: Boolean, default: false }
    },
	watch: {
		isDeputyGranted() {
			this.accountLimitMapping = this.buildAccountLimitMapping();
		}
	},
    components: {
        MoneyAmountInput
    },
    data() {
        return {
            accountLimitMapping: this.buildAccountLimitMapping()
        };
    },
    methods: {
        buildAccountLimitMapping() {
            let mapping = {};

            this.accounts.forEach(account => {
                let limit = this.limits ? this.limits.find(limit => limit.accountId === account.id) : null;
                let isAssigned = this.isDeputyGranted || (this.assignedAccounts ? this.assignedAccounts.includes(account.id) : false);
                // defaults if no limit exists
                if (!limit) {
                    limit = { hasBuyLimit: false, maxBuyAmount: 0 }
                }

                mapping[account.id] = {
                    account: account,
                    isAssigned: isAssigned,
                    withoutLimit: !limit.hasBuyLimit,
                    maxBuyAmount: limit.maxBuyAmount,
                };
            });

            return mapping;
        },
        getLimits() {
            let limits = [];

            for (let accountId in this.accountLimitMapping) {
                let accountLimit = this.accountLimitMapping[accountId];

                limits.push({
                    accountId: accountId,
                    hasBuyLimit: !accountLimit.withoutLimit,
                    maxBuyAmount: !accountLimit.withoutLimit ? accountLimit.maxBuyAmount : null
                });
            }

            return limits;
        },
        getAssignedAccounts() {
            let assignedAccounts = [];

            for (let accountId in this.accountLimitMapping) {
                let accountLimit = this.accountLimitMapping[accountId];

                if (accountLimit.isAssigned) {
                    assignedAccounts.push(accountId);
                }
            }

            return assignedAccounts;
        }
    },
};
</script>